'use strict';

var flexHttpError = require('../models/flexHttpError.cjs');

const isFlexHttpError = (error) => {
  return error instanceof Error && "code" in error && "message" in error;
};
const toFlexHttpError = (errorDto) => {
  if (typeof errorDto === "string") {
    return new flexHttpError.FlexHttpError(
      "UNKNOWN_ERROR",
      getUnknownErrorMessage(errorDto),
      400
    );
  }
  if (typeof errorDto !== "object" && !(errorDto instanceof Error)) {
    throw new Error("errorDto is not an object nor an error instance");
  }
  try {
    const {
      code,
      message,
      status = 900,
      title,
      trace
    } = errorDto;
    return new flexHttpError.FlexHttpError(code, message, status, title, trace);
  } catch (e) {
    throw new Error("errorDto is not a FlexHttpError");
  }
};
const getUnknownErrorMessage = (errorMessage) => {
  const isErrorMessageVeryHTMLLike = errorMessage.trim().startsWith("<") && errorMessage.length > 100;
  if (isErrorMessageVeryHTMLLike) {
    const isNegligible = errorMessage.includes("502 Bad Gateway") || errorMessage.includes("504 Gateway Time-out");
    return isNegligible ? "Unknown HTML error" : `Unknown HTML error (${errorMessage.slice(0, 100)}...)`;
  }
  return errorMessage;
};

exports.isFlexHttpError = isFlexHttpError;
exports.toFlexHttpError = toFlexHttpError;
//# sourceMappingURL=flexHttpError.cjs.map
